import { LabelModel } from '../../models/labels/label.model';
import { LabelCollapseModeEnum } from '../../models/labels/label-collapse-mode';

export const ContextLabelId = 'context-label';
export class StoryLabelsStateModel {
    loading: boolean;
    labelsCollapsed: boolean;
    labelsCollapsedMode: LabelCollapseModeEnum;
    labelScale: number;
    labels: LabelModel[];
    selectedLabel: string;
    contextLabel: LabelModel;
    enableContextLabel: {
        enable: boolean;
        enableInfo: boolean;
        enableActions: boolean;
    };

    draggable: {
        pin: boolean;
        tag: boolean;
    };
}
